import { DatePipe } from '@angular/common';
import { Column } from '@shared';

export class Task {
  @Column({
    title: 'Task Id',
    field: 'taskId',
    order: 0.1,
    width: 10,
    sortable: true,
    filterable: true,
    filterType: 'text',
    visibleInQuickView: true,
  })
  taskId: string = '';

  @Column({
    title: 'Restaurant Number',
    field: 'restaurantNo',
    order: 0.1,
    width: 20,
    sortable: true,
    filterable: true,
    filterType: 'text',
    visibleInQuickView: true,
  })
  restaurantNo: string = '';

  @Column({
    title: 'Task Name',
    field: 'taskName',
    order: 0.1,
    width: 20,
    sortable: true,
    filterable: true,
    filterType: 'text',
    visibleInQuickView: true,
  })
  taskName: string = '';

  @Column({
    title: 'Sent On',
    field: 'sentDt',
    order: 0.1,
    width: 20,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    filterable: true,
    filterType: 'date',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  sentDt: Date | null = null;

  @Column({
    title: 'Details',
    field: 'details',
    order: 0.1,
    width: 20,
    sortable: false,
    visibleInQuickView: false,
  })
  details: string = '';
}
